export default {
  validation: {
    required: "Il s'agit d'une question obligatoire.",
    kana_format: 'Saisir dans Katakana',
    email_format: "@.lower:validation.variables.email n'est pas correct",
    date_format: 'Saisir dans @.lower:validation.variables.date',
    number_format: 'Saisir dans @.lower:validation.variables.number',
    halfwidth_number_format: 'Ne saisissez que des chiffres de demi-largeur',
    alphanumeric_format: 'Saisir dans @.lower:validation.variables.alphanumeric ',
    postal_number_no_hyphen: 'Saisir dans @.lower:validation.variables.postal_number',
    postal_number_format: 'Saisir dans @:validation.variables.postal_number',
    login_email_required: '@:validation.required',
    login_email_format: '@:validation.email_format',
    login_password_required: '@:validation.required',
    // login_password_format: "",
    // min_length: "",
    // max_length: "",
    // greater_than_or_equal_number: "",
    // greater_than_number: "",
    // less_than_or_equal_number: "",
    // less_than_number: "",
    max_digit: "Veuillez saisir jusqu'à {digit} chiffres.",
    max_digit_with_item: 'Veuillez saisir {item} à {digit} chiffres près',
    // number_only: "",
    // decimal_max_digit: "",
    no_blank_or_newline: "Répondre uniquement avec des espaces et/ou des retours à la ligne n'est pas autorisé.",
    // invalid_zero_number: "",
    variables: {
      id_or_email: 'ID/Adresse e-mail',
      email: 'Adresse e-mail',
      password: 'Mot de passe',
      kana: '',
      date: 'Date (par exemple 31/01/2023)',
      number: 'Chiffre',
      alphanumeric: 'Lettres et chiffres',
      postal_number: 'Code postal',
    },
  },
}
